prismanoteApp.filter('startFrom', function () {
  return function (input, start) {
    if (!input || !start) { return }

    start = +start // parse to int
    return input.slice(start)
  }
})
